module.exports = __webpack_public_path__ + "img/icn-user-gps.e6c1c6bd.svg";